var defaultItemAsegurados = [{
  name_asegurado: null,
  brand: null,
  patente: null,
  materia_asegurada: null,
  comments: null,
  draft: null,
  is_new: false
}];
export default defaultItemAsegurados;